angular.module('powerOfAttorney')
    .controller('PowerOfAttorneyShowController', function ($scope, $rootScope, $uibModalInstance, PowerOfAttorney, data, PowerOfAttorneyService, PowerOfAttorneyConst, Principal) {
        this.PowerOfAttorneyService = PowerOfAttorneyService
        this.$onInit = () => {
            PowerOfAttorney.get({id: data.id}).$promise
                .then(result => {
                    this.item = result
                })
                .catch(() => $uibModalInstance.dismiss())
        }

        this.cancel = () => $uibModalInstance.dismiss()

        $scope.$on(PowerOfAttorneyConst.eventUpdate, () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit();
        })
        $scope.$on(PowerOfAttorneyConst.eventDelete, () => this.cancel())
        $scope.$on("file.saved", () => this.$onInit())
    })
